import {Link} from "react-router-dom"



  export const NavbarHover=()=>{



return <div>
     	
  <div class="navbw" id="navbar"  >
        <ul>
          {/* <li>
            <Link to="/sale" class="anchortag">SALE</Link>
          </li> */}
          <li>
            
            <Link to="/makeup" class="anchortag"> MAKEUP</Link>
            <div class="homediv">
              <div class="cnt">
                  <h6>FACE</h6>
                <p>Foundation</p>
                <p>Night Creams</p>  
                <p>BB & CC Cream</p> 
                <p>Concealer</p> 
                <p>Face Primer</p>
                 <p>Highlighter</p>
                 <p>Face Brushes</p>
              </div>
              <div class="cnt">
                  <h6>MAKEUP ACCESSORIES</h6>
                <p>Tweezers & Eyebrow Tools</p>
                <p>Makeup Removers</p> 
                <p>Sponges & Applicators</p>   
                <p>Makeup Bags & Travel Cases</p>
                      
              </div>
              <div class="cnt">
                  <h6>EYE</h6>
                <p>Mascara</p>
                <p>Eyeliner</p> 
               <p>Eyebrow</p>
              </div>
              <div class="cnt">
                  <h6>Eye Creams & Treatments</h6>
                <p>MASKS</p>
                <p>Face Masks</p> 
               <p>Shoot Masks</p>    
               <p>Ey ni Masks </p>
               <p></p> 
              </div>
              <div class="cnt">
                  <h6>LIP</h6>
                <p>Lipstick</p>
                <p>Lip Stain</p> 
               <p>Lip Gloss</p>    
               <p>Lip Liner </p>
               <p>Lip Balm & Treatment</p> 
               <p>Lip Brushes</p>
              </div>
            </div>
          </li>
          <li>
            <Link to="/skincare" class="anchortag"> SKINCARE</Link>
            <div class="homediv">
              <div class="cnt">
                  <h6>MOISTURIZERS</h6>
                <p>Moisturizers</p>
                <p>Night Creams</p>  
                <p>Mists & Essences</p> 
                <p>BB & CC Creams</p> 
                 
              </div>
              <div class="cnt">
                  <h6>CLEANSERS</h6>
                <p>Face Wash & Cleansers</p>
                <p>Makeup Removers</p> 
                <p>Face Wipes</p>   
                <p>Hand Sanitizers</p>
                <p>Eye Lashes</p> 
                <p>Assceories</p>      
              </div>
              <div class="cnt">
                  <h6>TREATMENTS & HIGH TECH TOOLS</h6>
                <p>Face Serums</p>
                <p>Cleansing Tools</p> 
               <p>Toners</p>     
              </div>
              <div class="cnt">
                  <h6>Eye Creams & Treatments</h6>
                <p>MASKS</p>
                <p>Face Masks</p> 
               <p>Shoot Masks</p>    
               <p>Ey ni Masks </p>
               <p></p> 
              </div>
            </div>
          </li>
          <li>
           
            <Link to="/fragrance" class="anchortag">FRAGRANCE</Link>
            <div class="homediv">
              <div class="cnt">
                  <h6>MENS</h6>
                <p>BODY SPRAY & DEODRANT</p>
                <p>PerFume</p>   
              </div>
              <div class="cnt">
                  <h6>WOMEN</h6>
                <p>Mists and Deodorants</p>
                <p>PerFume</p>   
              </div>
            </div>
          </li>
          <li>
            <Link to="/haircare" class="anchortag">HAIRCARE</Link>
            <div class="homediv">
              <div class="cnt">
                  <h6>SHAMPOO & CONDITIONER</h6>
                <p>Shampoo</p>
                <p>conditioners</p>   
              </div>
              <div class="cnt">
                  <h6>HAIR STYLING & TREATEMENTS</h6>
                <p>Hair Spray & Styling Product </p>
                <p>Hair Oil</p> 
                <p>Hair Masks</p>   
                <p>Hair Clips</p>     
              </div>
            </div>
          </li>
          <li>
            
            <Link to="toolsBrushes" class="anchortag">TOOLS & BRUSHES</Link>
            <div class="homediv">
              <div class="cnt">
                  <h6>BRUSHES</h6>
                <p>Face Brush</p>
                <p>Eye Brush</p>  
                <p>Lip Brush</p>  
                 
              </div>
              <div class="cnt">
                  <h6>TOOLS</h6>
                <p>Sponge & Application </p>
                <p>Face Tool</p> 
                <p>Hair Masks</p>   
                <p>Hair Clips</p>
                <p>Eye Lashes</p> 
                <p>Assceories</p>      
              </div>
              <div class="cnt">
                  <h6>VEGAN</h6>
                <p>Face Brush</p>
                <p>Eye Brush</p> 
               
                
                     
              </div>
            </div>
          </li>
          <li>
            <Link to="/brands" class="anchortag">BRAND</Link>
              <div class="homediv">
                  <div class="cnt">
                      <h6>MENS BRAND</h6>
                    <p>BODY SPRAY & DEODRANT</p>
                    <p>PerFume</p>   
                  </div>
                  <div class="cnt">
                      <h6>WOMEN BRAND</h6>
                    <p>Mists and Deodorants</p>
                    <p>PerFume</p>   
                  </div>
      
                </div>
          </li>
        </ul>
        
      </div>
</div>

}